import TimeIcon from "../../../../../../../../../assets/svg/time-icon";
import ActiveUserIcon from "../../../../../../../../../assets/svg/active-user-icon";
import NetworkIcon from "../../../../../../../../../assets/svg/network-icon";
import LocationIcon from "../../../../../../../../../assets/svg/location-icon";
import UtmMediumIcon from "../../../../../../../../../assets/svg/utm-medium-icon";
import AvailabilityIcon from "../../../../../../../../../assets/svg/availability-icon";

export type AgentDetailsConfigType = {
  id: string;
  icon: React.ElementType;
  header: string;
  subHeader: string;
};

export const AgentDetailsConfig = (isEditUser: boolean) => [
  {
    id: "shift_schedule",
    icon: TimeIcon,
    header: "Shift Schedule",
    subHeader: "Set the agent's workdays and shift hours.",
  },
  ...(isEditUser
    ? [
        {
          id: "agent_availability_leaves",
          icon: AvailabilityIcon,
          iconClassName: "w-5 h-5",
          header: "Agent Availability & Leaves",
          subHeader: "Define this agent's time-off and availability.",
        },
      ]
    : []),
  {
    id: "lead_assignment",
    icon: ActiveUserIcon,
    iconClassName: "w-5 h-5",
    header: "Lead Assignment",
    subHeader: "Assign leads by type, score, and distribution.",
  },
  {
    id: "countries_allowed_restricted",
    icon: NetworkIcon,
    header: "Countries Allowed / Restricted",
    subHeader: "Allow or block leads for this agent from specific countries.",
  },
  {
    id: "cities_allowed_restricted",
    icon: LocationIcon,
    iconClassName: "w-5 h-5",
    header: "Cities Allowed / Restricted",
    subHeader: "Allow or block leads for this agent from specific cities.",
  },
  {
    id: "utm_sources_allowed_restricted",
    icon: NetworkIcon,
    header: "UTM Sources Allowed / Restricted",
    subHeader: "UTM sources this agent can or cannot get leads from.",
  },
  {
    id: "utm_medium_allowed_restricted",
    icon: UtmMediumIcon,
    iconClassName: "w-5 h-5",
    header: "UTM Medium Allowed / Restricted",
    subHeader: "Allow or block leads by UTM medium.",
  },
];

export const CountryRestrictionsConfig = {
  id: "country_restrictions",
  whitelist_header: "Countries Whitelist",
  blacklist_header: "Countries Blacklist",
  placeholder: "Search or select country",
  search_placeholder: "Search countries...",
};

export const CityRestrictionsConfig = {
  id: "city_restrictions",
  whitelist_header: "Cities Whitelist",
  blacklist_header: "Cities Blacklist",
  placeholder: "Search or select city",
  search_placeholder: "Search cities...",
};

export const UtmSourceRestrictionsConfig = {
  id: "utm_source_restrictions",
  whitelist_header: "UTM Source Whitelist",
  blacklist_header: "UTM Source Blacklist",
  placeholder: "Search or select utm source",
  search_placeholder: "Search utm sources...",
};

export const UtmMediumRestrictionsConfig = {
  id: "utm_medium_restrictions",
  whitelist_header: "UTM Medium Whitelist",
  blacklist_header: "UTM Medium Blacklist",
  placeholder: "Search or select utm medium",
  search_placeholder: "Search utm mediums...",
};
